import React from 'react';
import { ReactComponent as LayersIcon } from '@src/assets/icons/layers.svg';
import { ArcCheckbox, ArcCollapse, ArcIconButton, ArcStack, ArcText, ArcTooltip } from '@src/core/ui';
import { LayersProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDisplayNoFlyZones, setDisplayNoFlyZones } from '@src/core/features';
// SAFE_LAND_DISABLED (2026-05): To restore: uncomment the import + selector + the safe-land checkbox JSX below.
// import { selectDisplaySafeLandZones, setDisplaySafeLandZones } from '@src/core/features';
import { useDisclosure } from '@src/core/hooks';

const Layers: React.FC<LayersProps> = () => {
  const dispatch = useDispatch();
  const { open, toggle } = useDisclosure();

  const displayNoFlyZones = useSelector(selectDisplayNoFlyZones);
  // SAFE_LAND_DISABLED (2026-05): To restore: uncomment.
  // const displaySafeLandZones = useSelector(selectDisplaySafeLandZones);
  return (
    <ArcStack alignItems='flex-end' sx={{ overflow: 'visible' }}>

      <ArcStack 
        width={50} 
        height={50} 
        borderRadius={2}
        alignItems='center' 
        justifyContent='center' 
        bgcolor='background.paper'>
        <ArcTooltip title='Layers'>
          <ArcIconButton onClick={toggle}>
            <LayersIcon />
          </ArcIconButton>
        </ArcTooltip>
      </ArcStack>

      <ArcCollapse in={open}>
        <ArcStack mt={1} py={1} pl={1} pr={2} borderRadius={2} bgcolor='background.paper' sx={{ boxShadow: 2 }}>
          <ArcStack direction='row' alignItems='center'>
            <ArcCheckbox 
              size='small' 
              color='brand'
              checked={displayNoFlyZones}
              onChange={(_, value) => {
                dispatch(setDisplayNoFlyZones(value));
              }} />
            <ArcText.h6>No-fly Zones </ArcText.h6>
          </ArcStack>
          {/* SAFE_LAND_DISABLED (2026-05): To restore: uncomment the ArcStack below.
          <ArcStack direction='row' alignItems='center'>
            <ArcCheckbox 
              size='small' 
              color='brand'
              checked={displaySafeLandZones}
              onChange={(_, value) => {
                dispatch(setDisplaySafeLandZones(value));
              }} />
            <ArcText.h6>Safe-land Zones </ArcText.h6>
          </ArcStack>
          */}
        </ArcStack>
      </ArcCollapse>
    </ArcStack>
  );
};

export default Layers;
